import GoogleTags from "./GoogleTags";
import cookies from "./CookieConsent";
import ContactForm from "./ContactForm";
import Events from "./Events";



(() => {
	GoogleTags.setListeners();
	cookies();
	ContactForm.setupWidgets();

	// Carousel initialization is handled in main script.js on window.load
	// Removed duplicate initialization to prevent duplicate dots and arrows

	// Lightbox initialization is handled in main script.js on window.load
	// Removed duplicate initialization to prevent multiple event listeners

})();

document.addEventListener(Events.ERROR, e => {
	if (e.target.tagName === 'IMG') {
		const src = e.target.src;
		if (src.indexOf('webp') > -1) {
			e.target.removeAttribute('srcset');
			e.target.removeAttribute('sizes');
			e.target.setAttribute('src', src.replace(/webp/g, 'jpg'));
		}
	}
}, true);
